export const SAVE = 'step4.SAVE';
export const VALUE_CHANGED = 'step4.VALUE_CHANGED';
export const LOAD = 'step4.VALUE_LOAD';
export const RESET = 'step4.RESET';



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step4/constants.js